// Iter-206 — <BannerShell> primitive.
//
// Single source of truth for the chrome of every site-wide banner:
//   - Full-bleed background (the colour is up to the caller — different
//     banners use navy, emerald, slate, amber, …).
//   - Inner row constrained to `max-w-wide` with the same horizontal
//     padding the page header uses, so banner copy lines up directly
//     under the CarSavr logo on the left and the primary CTA button on
//     the right — matching the homepage promo bar exactly.
//
// Consumers: SeasonalBanner, DetectedStateBanner (geo + saved branches),
// CompareSessionRecallBanner. Adding new banners? Wrap them in this
// shell so the alignment can never drift again.
//
// Iter-207 — Width constant re-exported from `<PageContainer>` so the
// canonical 1400px utility lives in exactly one place.
import { WIDE_PAGE_CONTAINER } from "./PageContainer";

// Kept as a named export for backwards-compatibility with iter-205/206
// regression tests that pin the constant name on this file.
export const BANNER_INNER_CONTAINER = WIDE_PAGE_CONTAINER;

export default function BannerShell({
  as: Tag = "div",
  className = "",
  innerClassName = "",
  role,
  ariaLabel,
  children,
  ...rest
}) {
  // `data-testid` (and any other native data-* / aria-* attrs) pass
  // through via `...rest` so call sites can write the testid as a
  // first-class JSX attribute — preserves literal-string regex pins
  // that QA suites rely on.
  return (
    <Tag
      {...rest}
      className={className}
      role={role}
      aria-label={ariaLabel}
    >
      <div className={`${BANNER_INNER_CONTAINER} ${innerClassName}`.trim()}>
        {children}
      </div>
    </Tag>
  );
}
